import React from 'react';
import './ReviewFormInput.css';

const ReviewFormInput = ({
  type = 'text',
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  label,
  error,
  touched,
  disabled = false,
  required = false,
  textarea = false,
  rows = 3,
  list,
}) => {
  const showError = error && touched;

  return (
    <div className={`rfi-wrapper${showError ? ' rfi-has-error' : ''}`}>
      {label && (
        <label className="rfi-label" htmlFor={name}>
          {label}
          {required && <span className="rfi-required"> *</span>}
        </label>
      )}
      <div className="rfi-input-row">
        {textarea ? (
          <textarea
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            rows={rows}
            className="rfi-field"
          />
        ) : (
          <input
            type={type}
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            list={list}
            className="rfi-field"
          />
        )}
      </div>
      {showError && <span className="rfi-error">{error}</span>}
    </div>
  );
};

export default ReviewFormInput;
